import { type ReactNode } from 'react'
import { WarningTriangleIcon } from '../icons/WarningTriangleIcon'
import { xStack, yStack } from '../patterns/stack'
import { errorMsg, infoMsg, labelStyles, warningIcon } from './InputBase.css'

type ChildrenProps = {
  hasError: boolean
  errorMessageId: string
}

export type InputBaseProps = {
  id?: string
  errorMessage?: string
  infoMessage?: string
  label?: string
}

type Props = InputBaseProps & { children: (props: ChildrenProps) => ReactNode }

export function InputBase({ id, errorMessage, infoMessage, label, children }: Props) {
  const hasError = errorMessage !== undefined
  const errorMessageId = `${id}-error`
  const hasInfo = infoMessage !== undefined && !hasError

  return (
    <div className={yStack({ gap: 'xs' })}>
      {label && (
        <label className={labelStyles} htmlFor={id}>
          {label}
        </label>
      )}
      <div className={yStack({ gap: 'xxs' })}>
        {children({ hasError, errorMessageId })}

        {hasInfo ? (
          <div>
            <span className={infoMsg}>{infoMessage}</span>
          </div>
        ) : (
          hasError && (
            <div className={xStack({ gap: 'xxs' })}>
              <WarningTriangleIcon className={warningIcon} />
              <span className={errorMsg} id={errorMessageId}>
                {errorMessage || 'PLACEHOLDER'}
              </span>
            </div>
          )
        )}
      </div>
    </div>
  )
}
